import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageSignDownloadUrlError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageSignDownloadUrlError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  key: z.string(),
  errorReason: z.string(),
});

export type S3StorageSignDownloadUrlError = z.infer<
  typeof S3StorageSignDownloadUrlError
>;
